<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productCategory.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('productCategory.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input v-model="search" v-tooltip="$t('productCategory.search')" :placeholder="$t('search')"
              style="width: 250px;" class="inline-block" />
          </div>
        </div>
      </ts-card-wrapper>
      <Table :data="resources" :columns="columns" size="small" highlight-row stripe max-height="700"
        :loading="loading">
        <template slot-scope="{ row }" slot="icon">
          <i :class="row.icon + ' fa-2x'"></i>
        </template>
        <template slot-scope="{ row }" slot="account">
          {{ row.account ? row.account.account_number + ' - ' + row.account.account_name_en : '-' }}
        </template>
        <template slot-scope="{ row }" slot="purchaseAccount">
          {{ row.purchase_account ? row.purchase_account.account_number + ' - ' + row.purchase_account.account_name_en :
            '-' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a href="#" v-tooltip="$t('edit')" class="text-primary mr-2" @click.prevent="edit(row)">
            <i class="fas fa-edit"></i>
          </a>
          <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
            :cancel-text="$t('no')" @confirm="deleteRecord(row)">
            <a href="#" :disabled="row._deleting">
              <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal v-if="showForm" v-model="showForm" :title="$t('productCategory.pageTitle')" centered @cancel="clearEdit"
        :zIndex="1020" :footer="null">
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'productCategoryIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('product/productCategory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.productCategory.search
      },
      set(newValue) {
        this.$store.commit('product/productCategory/SET_SEARCH', newValue)
        this.$store.commit('product/productCategory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('productCategory.code'),
          key: 'category_code'
        },
        {
          title: this.$t('productCategory.nameKh'),
          key: 'category_name_kh'
        },
        {
          title: this.$t('productCategory.nameEn'),
          key: 'category_name_en'
        },
        {
          title: this.$t('productCategory.account'),
          slot: 'account'
        },
        {
          title: this.$t('productCategory.purchaseAccount'),
          slot: 'purchaseAccount'
        },
        {
          title: this.$t('productCategory.icon'),
          slot: 'icon'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/productCategory/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('product/productCategory/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('product/productCategory/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('product/productCategory/destroy', record.category_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/productCategory/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
